var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUser02(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 28,
    viewBox: "0 0 33 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user-02"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.4985 20C12.2717 20 8.5129 22.0408 6.11982 25.208C5.60477 25.8896 5.34725 26.2304 5.35567 26.691C5.36218 27.0469 5.58565 27.4959 5.86565 27.7156C6.22808 28 6.73032 28 7.73481 28H25.2622C26.2667 28 26.7689 28 27.1313 27.7156C27.4114 27.4959 27.6348 27.0469 27.6413 26.691C27.6498 26.2304 27.3922 25.8896 26.8772 25.208C24.4841 22.0408 20.7253 20 16.4985 20Z",
    fill: "#A273FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4985 16C19.8122 16 22.4985 13.3137 22.4985 10C22.4985 6.68629 19.8122 4 16.4985 4C13.1848 4 10.4985 6.68629 10.4985 10C10.4985 13.3137 13.1848 16 16.4985 16Z",
    fill: "#A273FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4985 20C12.2717 20 8.5129 22.0408 6.11982 25.208C5.60477 25.8896 5.34725 26.2304 5.35567 26.691C5.36218 27.0469 5.58565 27.4959 5.86565 27.7156C6.22808 28 6.73032 28 7.73481 28H25.2622C26.2667 28 26.7689 28 27.1313 27.7156C27.4114 27.4959 27.6348 27.0469 27.6413 26.691C27.6498 26.2304 27.3922 25.8896 26.8772 25.208C24.4841 22.0408 20.7253 20 16.4985 20Z",
    stroke: "#A273FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4985 16C19.8122 16 22.4985 13.3137 22.4985 10C22.4985 6.68629 19.8122 4 16.4985 4C13.1848 4 10.4985 6.68629 10.4985 10C10.4985 13.3137 13.1848 16 16.4985 16Z",
    stroke: "#A273FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser02);
export default __webpack_public_path__ + "static/media/user-02.dbfb0d09ca30af7203e5446d5d01f1f4.svg";
export { ForwardRef as ReactComponent };